import { MdOutlineFlip, MdOutlineRotateRight, MdCheckCircle, MdChevronRight, MdCancel } from 'react-icons/md';
import styled from "styled-components/macro";

import { uiColors } from "../../common/styles";

export const DragPreviewWrapper = styled.section.attrs((props) => ({
    style: {
        background: props.background,
        top: `${props.$y}px`,
        left: `${props.$x}px`,
        visibility: props.$visible ? 'visible' : 'hidden',
        width: `${props.$width}px`,
        height: `${props.$height}px`,
    },
}))`
    position: fixed;
    overflow: hidden;
    z-index: 10;
    display: flex;
    align-items: center;
`;

export const ChevronUp = styled(MdChevronRight)`
    transform: rotate(-90deg);
    fill: ${uiColors.PRIMARY};
    font-size: 18px;
`;

export const ChevronDown = styled(MdChevronRight)`
    transform: rotate(90deg);
    fill: ${uiColors.PRIMARY};
    font-size: 18px;
`;

export const FlipVertical = styled(MdOutlineFlip)`
    transform: rotate(90deg);
    font-size: 20px;
`;

export const RotateRight = styled(MdOutlineRotateRight)`
    transform: scale(-1);
    font-size: 20px;
`;

export const CheckCircle = styled(MdCheckCircle)`
    fill: ${uiColors.PRIMARY_500};
    font-size: 18px;
`;

export const CheckCancel = styled(MdCancel)`
    fill: ${uiColors.PRIMARY_500};
    font-size: 18px;
`;
